// extracted by mini-css-extract-plugin
export default {"title":"U78Up","text":"iUpvR","buttonsContainer":"xiQfg","button":"Y4Nej","tablet":"fFSLI"};